/**
 * 🤖 AUTO-GENERATED FILE - DO NOT EDIT!
 *
 * Generated by vite-plugins/prodeng-routes.ts
 * Source: content/prodeng/2026-01-20_the-trust-tax.md
 */

import { createFileRoute } from '@tanstack/react-router';
import { ProdEngArticleLayout } from '@/components/ProdEngArticleLayout';
import { createArticleMeta } from '@/lib/meta';
import Content from '@/content/prodeng/the-trust-tax.mdx';

const metadata = {
  title: "The Trust Tax: What Low-Trust Environments Actually Cost",
  date: "2026-01-20",
  author: "Christian Battaglia",
  articleNumber: 4,
  seoDescription: "Low-trust organizations pay a 40% performance penalty. Learn why trust—not process or talent—determines whether your product engineering succeeds or fails.",
  linkedinUrl: "https://www.linkedin.com/pulse/trust-tax-what-low-trust-environments-actually-cost-battaglia-ruaje",
  heroImage: "/prodeng/the-trust-tax.webp",
  readTime: "15 min read",
  tags: ["trust","product engineering","engineering culture","organizational design","leadership","psychological safety","software engineering","performance"],
  published: true,
};

export const Route = createFileRoute('/prodeng/articles/the-trust-tax')({
  component: ArticlePage,
  head: () => createArticleMeta({
    title: `${metadata.title} — Product Engineering`,
    description: metadata.seoDescription || '',
    path: '/prodeng/articles/the-trust-tax',
    image: '/og/prodeng/the-trust-tax.png',
    imageAlt: metadata.title,
    datePublished: metadata.date,
    authorName: metadata.author,
    readTime: metadata.readTime,
    tags: metadata.tags,
    section: 'Product Engineering',
  }),
});

function ArticlePage() {
  return (
    <ProdEngArticleLayout {...metadata}>
      <Content />
    </ProdEngArticleLayout>
  );
}
